import { useMemo } from 'react';
import type { SearchParams } from '@/store/api/dataLayersApi';

interface UseSensorQueryParamsProps {
  siteId?: string;
  assetId?: string;
  assetName?: string;
  selectedComponentId?: string | null;
  selectedPart?: string | null;
  isMobileAsset: boolean;
  from: string;
  to: string;
  isFullPull: boolean;
  isSpectral?: boolean;
}

/**
 * Custom hook to build query parameters for sensor data API
 */
export function useSensorQueryParams({
  siteId,
  assetId,
  assetName,
  selectedComponentId,
  selectedPart,
  isMobileAsset,
  from,
  to,
  isFullPull,
  isSpectral = false,
}: UseSensorQueryParamsProps): SearchParams {
  return useMemo(() => {
    return {
      site_id: siteId!,
      asset_id: assetId!,
      asset_name: assetName,
      asset_supplier: '',
      asset_model: '',
      component_id: selectedComponentId?.includes('all') ? null : selectedComponentId,
      subcomponent_id: !selectedPart || selectedPart.includes('custom-part-analysis') ? null : selectedPart,
      asset_category: isMobileAsset ? 'mobile' : 'fixed',
      from_date: from,
      to_date: to,
      full_pull: isFullPull,
      is_spectral: isSpectral,
    };
  }, [selectedComponentId, assetId, siteId, assetName, selectedPart, to, from, isMobileAsset, isFullPull]);
}

/**
 * Enhanced query params with additional fields
 */
export function useEnhancedQueryParams(baseParams: SearchParams, additionalParams?: Record<string, any>) {
  return useMemo(
    () => ({
      ...baseParams,
      ...additionalParams,
    }),
    [baseParams, additionalParams]
  );
}
